import { useState } from "react";
import { useTranslation } from "next-i18next";

import { Modal } from "common/ui/Modal";
import { Paragraph } from "common/ui/Paragraph";

import { archiveListing } from "features/listings/api/archiveListing";

interface Props {
  close: () => void,
  closeOnSuccess: () => void,
  propertyId: number,
}

export function ArchiveListingModal({
  close,
  closeOnSuccess,
  propertyId,
}: Props) {
  const { t } = useTranslation(["admin", "validation"]);

  const [isArchiving, setIsArchiving] = useState(false);
  const [err, setErr] = useState("");

  const archive = async () => {
    setErr("");
    setIsArchiving(true);

    try {
      await archiveListing(propertyId);

      closeOnSuccess();
    } catch (err) {
      setErr(t("somethingWentWrong", { ns: "validation" }));
    }

    setIsArchiving(false);
  }

  return (
    <Modal
      close={close}
      title={t("archiveListingModal.confirm")}
      primaryAction={{
        text: t("archiveListingModal.archive"),
        onClick: archive,
      }}
      secondaryAction={{
        text: t("common.cancel"),
        onClick: close,
      }}
      isProcessing={isArchiving}
      error={err}
    >
      <Paragraph variant="p1">
        {t("archiveListingModal.areYouSure")}
      </Paragraph>
    </Modal>
  )
}
